import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Nav } from "@/components/site/Nav";
import { Seo } from "@/components/Seo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-cream text-olive-deep">
      <Seo title="Kjøpet ble avbrutt – Helserebellen" description="Kjøpet ble avbrutt." path="/payment/cancel" noindex />
      <Nav />
      <div className="min-h-screen grid place-items-center px-6 text-center">
        <div className="max-w-lg">
          <XCircle size={48} className="mx-auto text-olive/40" />
          <h1 className="mt-6 font-serif text-4xl">Kjøpet ble avbrutt</h1>
          <p className="mt-3 text-olive/70">Ingen bekymring – du er ikke belastet. Du kan prøve igjen når som helst.</p>
          <Link to="/#velg" data-testid="cancel-back"
            className="mt-8 inline-flex items-center gap-2 rounded-md bg-terra px-8 py-4 text-cream text-[13px] font-semibold uppercase tracking-[0.12em] hover:bg-olive-deep transition-colors">
            Tilbake til planene
          </Link>
        </div>
      </div>
    </div>
  );
}
